import styled from 'styled-components/macro';
import { white } from '../../styles/colors';
import Section from '../Section';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

const desktopEmail = media.desktop`
  width: 70%;
`
export const Email = styled.label`
  background-color: ${({ theme }) => theme.inlineBannerBgColor};
  color: ${white};
  margin: 0;
  padding: 20px 0;
  width: 100%;
  overflow-wrap: break-word;
  text-align: center;
  ${desktopEmail};
`;

const desktopSection = media.desktop`
  padding: 40px 45px;
`
export const StyledSection = styled(Section)`
  padding: 40px 30px;
  h2 {
    ${fontSize(18)};
    margin-bottom: 25px;
  }
  h3 {
    ${fontSize(16)};
    margin-bottom: 20px;
  }
  ${desktopSection};
`;
